var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarkPin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99976 5.6773C9.99976 5.70889 9.99947 5.74041 9.99891 5.77186H9.99976C9.99976 11.1605 4.99973 13.4294 4.99973 13.4294C4.99973 13.4294 -0.000244141 11.1605 -0.000244141 5.77186H0.000596576C3.69029e-05 5.74041 -0.000244141 5.70889 -0.000244141 5.6773C-0.000244141 2.85787 2.23833 0.572266 4.99976 0.572266C7.76118 0.572266 9.99976 2.85787 9.99976 5.6773ZM4.99986 9.2694C6.94308 9.2694 8.51838 7.66101 8.51838 5.67697C8.51838 3.69293 6.94308 2.08454 4.99986 2.08454C3.05664 2.08454 1.48134 3.69293 1.48134 5.67697C1.48134 7.66101 3.05664 9.2694 4.99986 9.2694Z",
    fill: "#3B3B3B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarkPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dark-pin.411e2dbffdf485c9bbace9548c7255d2.svg";